import { useRef } from 'react';
import { AttachmentGroupsForm } from '../../components/forms/AttachmentGroupsForm';
import Modal from '../../components/ui/Modal';
import type { AttachmentGroupDto } from '../../services/attachments/attachment.types';

interface Props {
    group: AttachmentGroupDto | null;
    submitting: boolean;
    onSubmitting: (submitting: boolean) => void;
    onSaved: (group: AttachmentGroupDto) => void;
    onCancel: () => void;
}

export function AttachmentGroupEditor({ group, submitting, onSubmitting, onSaved, onCancel }: Props) {
    const contentRef = useRef<HTMLDivElement>(null);

    const submit = () => {
        const form = contentRef.current?.querySelector('form');
        if (!form) throw new Error('Attachment group form is not mounted');
        if (typeof form.requestSubmit === 'function') {
            form.requestSubmit();
        } else {
            form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        }
    };

    return (
        <Modal
            isOpen
            title={group ? 'Edit Attachment Group' : 'Add Attachment Group'}
            content={
                <div ref={contentRef} id={group ? 'attachment-group-edit-form' : 'attachment-group-form'}>
                    <AttachmentGroupsForm
                        key={group?.id ?? 'new'}
                        onSubmit={onSaved}
                        onCancel={onCancel}
                        initialData={group ? {
                            profileName: group.profileName,
                            existingAttachments: group.attachments,
                            siteRuleCount: group.siteRuleAttachmentGroups?.length ?? 0,
                        } : undefined}
                        isLoading={submitting}
                        groupId={group?.id}
                        onSubmitting={onSubmitting}
                    />
                </div>
            }
            onConfirm={submit}
            onCancel={onCancel}
            closeOnOverlayClick={false}
        />
    );
}
